import { render } from "./AsGoToCommunity.vue?vue&type=template&id=7e762a4c&scoped=true&ts=true"
import script from "./AsGoToCommunity.vue?vue&type=script&lang=ts"
export * from "./AsGoToCommunity.vue?vue&type=script&lang=ts"

import "./AsGoToCommunity.vue?vue&type=style&index=0&id=7e762a4c&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e762a4c"]])

export default __exports__